import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { Subject } from 'rxjs';
import { HelperService } from '../../services/helper.service';
import { SupaService } from '../../services/supa.service';

@Component({
  selector: 'app-usersearch',
  templateUrl: './usersearch.component.html',
  styleUrls: ['./usersearch.component.scss'],
})
export class UserSearchDialog implements OnInit {

  @Input('locationcode') locationcode = ""
  employeeid = ""
  namefilter = ""
  rolefilter = ""

  SearchResults: Subject<UserSearchResult[]|null|undefined> = new Subject<UserSearchResult[]|null|undefined>();
  constructor(private modalController: ModalController, private supa: SupaService, private helper: HelperService) { }

  ngOnInit() {
    this.init();
  }

  async init() {
    let filters:string[] = []
    const limit = 10;

    this.SearchResults.next(undefined);

    let query = this.supa.supabase.from("employee")
      .select("id,name,role!inner(name),iqlocation!inner(code)")
      .ilike("iqlocation.code",`%${this.locationcode}%`)
      .ilike("name",`%${this.namefilter}%`)
      .ilike("role.name", `%${this.rolefilter}%`)

    if(this.employeeid!=""){
      query = query.eq("id",+this.employeeid)
    }
    let result = await query;
    this.SearchResults.next(result.data);
  }

  dismissModal() {
    this.modalController.dismiss();
  }

  selectUser(user :UserSearchResult) {
    this.helper.createAndOpenAlert(user.name, 'Do you want to select this user?', () => {
      this.modalController.dismiss({user:user});
    }, [])
  }

}

export interface UserSearchResult {
  id: string;
  name: string;
  iqlocation: any;
  role:any;
}